export default __webpack_public_path__ + "static/media/content.37592a62.jpg";